import { createBrowserRouter, Navigate } from 'react-router';
import { RequireAuth } from '../shared/features/session/components/RequireAuth';
import { RATE_CARD_ROUTES } from '../features/rate-cards/rate-cards.routes';
import { FLEET_ROUTES } from '../features/fleet/fleet.routes';
import { INTEGRATION_ROUTES } from '../features/integrations/integrations.routes';
import { MAINTENANCE_ROUTES } from '../features/maintenance/maintenance.routes';
import { JOB_ROUTES } from '../features/jobs/jobs.routes';
import { REFERENCE_DATA_ROUTES } from '../features/reference-data/reference-data.routes';
import { ZONE_ROUTES } from '../features/zones/zones.routes';
import { ACCOUNTING_PERIOD_ROUTES } from '../features/accounting-periods/accounting-periods.routes';
import { APPROVAL_THRESHOLD_ROUTES } from '../features/approval-thresholds/approval-thresholds.routes';
import { COMPANY_ACCOUNT_ROUTES } from '../features/company-accounts/company-accounts.routes';
import { COMPANY_SETTINGS_ROUTES } from '../features/company-settings/company-settings.routes';
import { COMPLIANCE_ROUTES } from '../features/compliance/compliance.routes';
import { DISPATCH_ROUTES } from '../features/dispatch/dispatch.routes';
import { DEADLINE_ROUTES } from '../features/deadlines/deadlines.routes';
import { ROLE_ROUTES } from '../features/roles/roles.routes';
import { ACCOUNT_ROUTES } from '../features/account/account.routes';
import { BILLING_ROUTES } from '../features/billing/billing.routes';
import { CUSTOMER_ROUTES } from '../features/customers/customers.routes';
import { DRIVER_ROUTES } from '../features/drivers/drivers.routes';
import { ALERT_ROUTES } from '../features/alerts/alerts.routes';
import { LIVE_MAP_ROUTES } from '../features/live-map/live-map.routes';
import { EXPENSE_ROUTES } from '../features/expenses/expenses.routes';
import { USER_ROUTES } from '../features/users/users.routes';
import { AppLayout } from './components/AppLayout';
import { OFFICE_SECTIONS } from '../shared/components/office-sections';
import { YardLayout } from './components/YardLayout';
import { LOGIN_ROUTE } from '../features/login/login.routes';
import { NotFound } from './pages/NotFound';
import { RouteErrorPage } from './pages/RouteErrorPage';
import { SectionPage } from './pages/SectionPage';
import { YardTasksPage } from './pages/YardTasksPage';

export const router = createBrowserRouter([
  { ...LOGIN_ROUTE, errorElement: <RouteErrorPage fullScreen /> },
  {
    element: <RequireAuth />,
    // Above the shells (the layout or auth itself failed), so the fallback stands on its own.
    errorElement: <RouteErrorPage fullScreen />,
    children: [
      {
        path: '/',
        element: <AppLayout />,
        // A page that throws shows RouteErrorPage inside the shell, so the navigation still works.
        children: [
          {
            errorElement: <RouteErrorPage />,
            children: [
              { index: true, element: <Navigate to="/dispatch" replace /> },
              ...ACCOUNT_ROUTES,
              ...ROLE_ROUTES,
              ...USER_ROUTES,
              ...ACCOUNTING_PERIOD_ROUTES,
              ...APPROVAL_THRESHOLD_ROUTES,
              ...REFERENCE_DATA_ROUTES,
              ...ZONE_ROUTES,
              ...COMPANY_SETTINGS_ROUTES,
              ...JOB_ROUTES,
              ...CUSTOMER_ROUTES,
              ...BILLING_ROUTES,
              ...RATE_CARD_ROUTES,
              ...FLEET_ROUTES,
              ...MAINTENANCE_ROUTES,
              ...DRIVER_ROUTES,
              ...COMPLIANCE_ROUTES,
              ...DEADLINE_ROUTES,
              ...DISPATCH_ROUTES,
              ...INTEGRATION_ROUTES,
              ...ALERT_ROUTES,
              ...LIVE_MAP_ROUTES,
              ...EXPENSE_ROUTES,
              ...COMPANY_ACCOUNT_ROUTES,
              ...OFFICE_SECTIONS.filter(
                (section) =>
                  ![
                    'roles',
                    'users',
                    'accounting-periods',
                    'approval-thresholds',
                    'reference-data',
                    'zones',
                    'company',
                    'jobs',
                    'customers',
                    'billing',
                    'rate-cards',
                    'fleet',
                    'maintenance',
                    'drivers',
                    'compliance',
                    'deadlines',
                    'integrations',
                    'alerts',
                    'live-map',
                    'expenses',
                    'dispatch',
                  ].includes(section.slug),
              ).map((section) => ({
                path: section.slug,
                element: <SectionPage section={section} />,
              })),
            ],
          },
        ],
      },
      {
        path: '/yard',
        element: <YardLayout />,
        children: [{ errorElement: <RouteErrorPage />, children: [{ index: true, element: <YardTasksPage /> }] }],
      },
    ],
  },
  { path: '*', element: <NotFound /> },
]);
